import { render, staticRenderFns } from "./VCounter.vue?vue&type=template&id=5d083d8a"
import script from "./VCounter.vue?vue&type=script&lang=js"
export * from "./VCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports